module.exports = __webpack_public_path__ + "static/media/Noto4.fe17683a.webp";